'use strict'

import * as stateKeys from './constants/state-keys'

export const isEventsJsonLoadedGetter = state => state[stateKeys.IS_EVENTS_JSON_LOADED]
export const eventsJsonGetter = state => state[stateKeys.EVENTS_JSON]
